import { Typography } from "@mui/material";

const PageNotFound = () => {
  return <Typography>Page Not Found</Typography>;
};

export default PageNotFound;
